import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import only those that are used
import {
	MdButton,
	MdIcon,
	MdField,
	MdCard
} from "vue-material/dist/components";
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

var importedMds = [
	MdButton,
	MdIcon,
	MdField,
	MdCard
];
importedMds.forEach(x => Vue.use(x));

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
